import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import TeamDetailsMain from './TeamDetailsMain';
import Footer from '../../components/Footer';

const TeamDetails = () => {
  return (
    <>
      <HeaderSeven />

      <TeamDetailsMain />

      <Footer />
    </>
  );
};

export default TeamDetails;
